import React, { Dispatch, SetStateAction, useCallback, useState } from 'react'

import toast from 'react-hot-toast'

import { Button } from '../..'
import { useProfileForm, useUser } from '../../../context'
import Modal from '../../modal/Modal'

const ButtonsSection = ({
  showCredentials,
  setShowCredentials,
}: {
  showCredentials: boolean
  setShowCredentials: Dispatch<SetStateAction<boolean>>
}) => {
  const { values, save, create, isDirty, loading, cancel, isNewUser } =
    useProfileForm()
  const { user, onEditionMode } = useUser()
  const [inviteLink, setInviteLink] = useState<string | null>(null)
  const [showInviteModal, setShowInviteModal] = useState(false)

  const handleCreate = useCallback(async () => {
    const result = await create()
    if (result?.verificationLink) {
      setInviteLink(result.verificationLink)
      setShowInviteModal(true)
    }
  }, [create])

  const handleCopy = async () => {
    if (!inviteLink) return
    try {
      await navigator.clipboard.writeText(inviteLink)
      toast.success('Enlace copiado')
    } catch (error) {
      console.error(error)
      toast.error('No se pudo copiar el enlace')
    }
  }

  return (
    <>
      {onEditionMode && (
        <>
          {!showCredentials && (
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'space-between',
                // alignItems: 'center',
                gap: 20,
              }}
            >
              {values.uid === user?.uid && (
                <Button
                  className="light-blue"
                  onClick={() => setShowCredentials(!showCredentials)}
                  label="Cambiar credenciales de acceso"
                  fontSize={16}
                />
              )}
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  gap: 20,
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
              >
                <Button
                  className="light-grey"
                  onClick={cancel}
                  label="Cancelar"
                  fontSize={14}
                  disabled={loading}
                />
                <Button
                  className="dark-grey"
                  onClick={isNewUser ? handleCreate : save}
                  label={isNewUser ? 'Crear Usuario' : 'Guardar Datos'}
                  fontSize={14}
                  disabled={!isDirty || loading}
                />
              </div>
            </div>
          )}
        </>
      )}

      {showInviteModal && inviteLink && (
        <Modal onClose={() => setShowInviteModal(false)}>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
            <h3>Enlace de verificación</h3>
            <p>
              Copia o comparte este enlace para que el nuevo administrador
              active su cuenta.
            </p>
            <a
              href={inviteLink}
              target="_blank"
              rel="noreferrer"
              style={{ wordBreak: 'break-all', color: '#08a8d2' }}
            >
              {inviteLink}
            </a>
            <div
              style={{ display: 'flex', gap: 12, justifyContent: 'flex-end' }}
            >
              <Button
                className="light-blue"
                onClick={handleCopy}
                label="Copiar enlace"
                fontSize={14}
              />
              <Button
                className="dark-grey"
                onClick={() => setShowInviteModal(false)}
                label="Cerrar"
                fontSize={14}
              />
            </div>
          </div>
        </Modal>
      )}
    </>
  )
}

export default ButtonsSection
